export const reactSelectBaseProps = {
  autoBlur: true,
  allowCreate: false,
  autoload: false,
  backspaceRemoves: true,
  cacheAsyncResults: true,
  className: null,
  clearable: false,
  clearAllText: '',
  clearValueText: '',
  delimiter: ',',
  disabled: false,
  escapeClearsValue: true,
  ignoreCase: true,
  inputProps: {},
  isLoading: false,
  labelKey: 'label',
  loadOptions: null,
  matchPos: 'any',
  matchProp: 'any',
  scrollMenuIntoView: true,
  menuBuffer: 20,
  multi: false,
  name: '',
  newOptionCreator: null,
  noResultsText: '',
  onBlur: null,
  onBlurResetsInput: true,
  onChange: null,
  onFocus: null,
  onInputChange: null,
  onValueClick: null,
  onOpen: null,
  onClose: null,
  optionRenderer: null,
  options: [],
  placeholder: 'This is a placeholder',
  searchingText: '',
  searchPromptText: '',
  simpleValue: true,
  value: null,
  valueKey: 'value',
  valueRenderer: null
};
